"use strict";

import { initMenu } from '../components/menu.js';
import { initBanner } from '../components/banner.js';
import { initFooter } from '../components/footer.js';
import { initGuestConfirmationForm } from '../components/guest-confirmation-form.js';

const initializeCountdownTimer = () => {
  const countDownDate = new Date("Jun 21, 2025 14:54:00").getTime();
  countdownInterval = setInterval(() => updateCountdown(countDownDate), 1000);
};

const updateCountdown = (countDownDate) => {
  const now = new Date().getTime();
  const distance = countDownDate - now;

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  $("#days").html(`${days} <small>days</small>`);
  $("#hours").html(`${hours} <small>hours</small>`);
  $("#minutes").html(`${minutes} <small>minutes</small>`);
  $("#seconds").html(`${seconds} <small>seconds</small>`);

  if (distance < 0) {
    clearInterval(countdownInterval);
    $("#countdown").hide();
    $("#finished").html("Viiiivent les marié.e.s!!!");
  }
};

export function initHome() {
  console.log("Initialisation de la page d'accueil");
  initBanner();
  initMenu();
  initializeCountdownTimer();
  initGuestConfirmationForm();
  initFooter();
}

module.exports = { initHome };